import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatNumber } from "../../../utils/DefaultFunction";

export default function ChannelPerformanceChart({ data }) {
  const chartHeight = 600;

  function prepareChartData(data) {
    const categories = data.map(item => item.channel);
    const deliveredData = data.map(item => item.delivered);
    const readData = data.map(item => item.read);
    return { categories, deliveredData, readData };
  }

  const { categories, deliveredData, readData } = prepareChartData(data);

  const options = {
    chart: {
      type: "column",
      renderTo: "highcharts-container",
      height: chartHeight,
      backgroundColor: "transparent",
      style: {
        fontFamily: "Inter, sans-serif",
      },
    },
    legend: { enabled: true }, // keep legends to differentiate delivered vs read
    title: {
      text: null,
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
        color: "#1f2937",
      },
    },
    subtitle: {
      text: null,
      align: "left",
      style: {
        color: "#6b7280",
      },
    },

    xAxis: {
      categories: categories,
      title: { text: null },
      labels: {
        style: { fontSize: "12px" },
        rotation: 0,
      },
    },

    yAxis: {
      min: 0,
      title: {
        text: "Messages",
        align: "middle",
      },
      labels: {
        overflow: "justify",
        formatter: function () {
      return formatNumber(this.value, "en-US", true);
    },
      },
      gridLineWidth: 1,
    },

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let s = `<b>${this.x}</b><br/>`;

        this.points.forEach(point => {
          s += `
            <div style="margin:4px 0;">
              <span style="color:${point.series.color}">${point.series.name}:</span> 
              <b style="color:${point.series.color}">${formatNumber(point.y)}</b>
            </div>`;
        });

        return s;
      },
    },

    plotOptions: {
      column: {
        borderRadius: 2,
        pointPadding: 0.1,
        groupPadding: 0.2,
        dataLabels: {
          enabled: true,
          inside: false,
          style: {
            fontSize: "11px",
            fontWeight: "600",
            color: "#374151",
          },
          formatter: function () {
            return this.y === 0 ? null : formatNumber(this.y);
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Delivered Messages",
        data: deliveredData,
        color: "#10b981", // green
      },
      {
        name: "Read Messages",
        data: readData,
        color: "#3b82f6", // blue
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
